import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getPKS(pathname, queryParams = "", extraHeaders = {}) {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams, {
    headers: extraHeaders,
  });
}

export async function getPKSById(pathname, extraHeaders = {}) {
  return await instance({ baseURL: baseURL }).get(pathname, {
    headers: extraHeaders,
  });
}

export async function createPKS(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/pks" + pathname, body);
}

export async function updatePKS(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/pks" + pathname, body);
}

export async function deletePKS(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).delete("/pks" + pathname, { data: body }); // axios delete: body harus di { data: ... }
}

export async function verifyPKSByHead(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/pks" + pathname, body);
}

// Fetch tagihan tetap (fixed utility charge) dari PKS aktif untuk unit tertentu.
// Digunakan untuk auto-fill field unit_price di form input utility reading mode lumpsum.
export async function getUtilityChargeByUnit(unit_id, utility_type) {
  return await instance({ baseURL }).get(
    `/pks/utility-charge?unit_id=${unit_id}&utility_type=${utility_type}`,
  );
}

export async function bulkCreatePKS(pksList) {
  return await instance({ baseURL }).post("/pks/bulk", { pks: pksList });
}
